import { ApolloCache } from "@apollo/client"

import { evict } from "shared/api/evict"
import { FloorTypename } from "shared/types/Project"

export function evictFloor(id: string, cache: ApolloCache<object>) {
  evict({
    cache,
    id,
    typename: FloorTypename
  })
}
